<script setup>
const props = defineProps({
  color: {
    type: String,
    default: 'stone',
  },
})
</script>
<template>
    <h2 :class="`text-3xl font-semibold leading-7 text-${color}-600 sm:text-4xl`">
    <slot/>
  </h2>
</template>
